import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { couponGeneric, mopGeneric } from '../../constants/ServerErrors';
import { inSufficientFundsErrorCodes, multiMonthBillingPeriod, ServerErrorsDataMap } from '../../constants/ServerErrorsDataMap';
import { FieldLabels, Validations } from '../../constants/Strings';
import { parseString } from '../../utils/StringUtils';
export var getValidationMessage = function getValidationMessage(type, field) {
  return parseString(Validations[type], {
    field: FieldLabels[field]
  });
};

/**
 * extract mapped error code logic and export it as method
 * @param code
 * @param errorMapperParameters
 * @returns string mapped errorCode
 */
export var getMappedErrorCode = function getMappedErrorCode(code, errorMapperParameters) {
  if (!code) {
    return mopGeneric.message_id;
  }
  var _ref = errorMapperParameters || {},
    billingPeriods = _ref.billingPeriods;
  if (typeof code === 'number') {
    return code.toString();
  }

  //Errors from new CART & CHECKOUT services comes back as PAYMENT rather than pmt
  var mappedCode = code.replace('PAY-', 'pmt');

  //Map multi month error codes
  mappedCode = billingPeriods !== null && billingPeriods !== void 0 && billingPeriods.filter(function (billingPeriod) {
    return billingPeriod && multiMonthBillingPeriod.includes(billingPeriod.toUpperCase());
  }).length && inSufficientFundsErrorCodes.includes(mappedCode) ? "".concat(mappedCode, "-MM") : mappedCode;
  return mappedCode;
};
export var getMopError = function getMopError(code, errorMapperParameters) {
  if (!code) {
    return mopGeneric;
  }
  var mappedCode = getMappedErrorCode(code, errorMapperParameters);
  if (typeof code === 'number') {
    return _objectSpread(_objectSpread({}, mopGeneric), {}, {
      message_id: mappedCode
    });
  }
  var serverError = ServerErrorsDataMap.get(mappedCode);
  if (!serverError) {
    return _objectSpread(_objectSpread({}, mopGeneric), {}, {
      message_id: code
    });
  }
  return _objectSpread(_objectSpread({}, serverError), {}, {
    message_id: code
  });
};
export var getCouponError = function getCouponError(code) {
  var serverError = ServerErrorsDataMap.get(code);
  if (serverError) {
    return _objectSpread(_objectSpread({}, serverError), {}, {
      message_id: code
    });
  }
  return _objectSpread(_objectSpread({}, couponGeneric), {}, {
    message_id: code
  });
};
var ValidationMessageMethods = {
  getValidationMessage: getValidationMessage,
  getMopError: getMopError,
  getCouponError: getCouponError,
  getMappedErrorCode: getMappedErrorCode
};
export default ValidationMessageMethods;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/business/validators/ValidationMessages.js
// module id = 840
// module chunks = 11